import { INCIDENT_SCHEMA_VERSION } from './contract';
import { offlineDb } from './offline-db';
import { warmupLogoCache } from './logo-cache-warmup';

const SNAPSHOT_ID = 'latest';

/**
 * Persist Auth/Init payload for offline form configuration.
 * @param {Object} init - Init response (organizations interpolated upstream)
 */
export async function saveInitSnapshot(init) {
  await offlineDb.initSnapshots.put({
    id: SNAPSHOT_ID,
    init,
    schemaVersion: INCIDENT_SCHEMA_VERSION,
    storedAt: new Date().toISOString()
  });

  warmupLogoCache().catch((err) => {

  });
}

/**
 * @returns {Promise<{ init: Object, schemaVersion: string, storedAt: string } | undefined>}
 */
export async function getInitSnapshot() {
  return offlineDb.initSnapshots.get(SNAPSHOT_ID);
}